// MIRRORS: panel/auth/sessionFreshness.ts — identical copy; edit both, or delete this line on both to declare a deliberate split.
/**
 * When a cached "signed in" answer is too old to trust. The user lives in
 * memory, so a tab left open overnight keeps rendering authed screens. Reused
 * for a short window so navigation does not cost a request each time.
 */
export const SESSION_RECHECK_MS = 60_000;

/**
 * @param lastCheckedAt epoch ms of the last probe, or null if never probed.
 * @param now epoch ms.
 */
export const shouldRevalidate = (
  lastCheckedAt: number | null,
  now: number,
  minIntervalMs: number = SESSION_RECHECK_MS
): boolean => {
  if (lastCheckedAt === null) return true;
  // A backwards clock must not pin the session as permanently fresh.
  if (now < lastCheckedAt) return true;
  return now - lastCheckedAt >= minIntervalMs;
};
